import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";
import { DialogType } from "../../../isp._comun/iu/_principal/constantesIuPrin";

export default class VentanaSeleccionarCliente extends Ventana {
    constructor(notificarClienteSeleccionado) {
        super();
        this.id= DialogType.SELECCIONAR_CLIENTE;
        this.notificarClienteSeleccionado=notificarClienteSeleccionado;
        // this.ventanaCargando = null;
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaSeleccionarCliente)) {
            return false;
        }

        return true;
    }

    clonar() {
        const nuevaVentana = new VentanaSeleccionarCliente(this.notificarClienteSeleccionado);
        nuevaVentana.posicionZ = this.posicionZ;
        // nuevaVentana.id = this.id;
        // nuevaVentana.ventanaCargando = this.ventanaCargando;
        return nuevaVentana;
    }
}
